import track from './track.js';
import getClosestComponentID from './get-closest-component-id.js';
import getParentElements from './get-parent-elements.js';

export default function handleTrackingAttribute(type) {
  document.addEventListener(type, ({ target }) => {
    const attributeName = `data-track-${type}`;
    // Go up the tree to track all the elements with the data attribute
    // Always include the target itself even if it don't have the attribute (ex. for click, it's eq. to `data-track-click="click"`)
    const nodes = [target, ...[...getParentElements(target)].filter((n) => n?.hasAttribute?.(attributeName) ?? false)];
    for (const node of nodes) {
      const { action, type: trackType, attributes } = parseData(node.getAttribute(attributeName)) ?? {};

      track({
        eventInfo: { eventAction: action ?? type, type: trackType ?? 'event' },
        componentID: getClosestComponentID(node),
        attributes: new Object(attributes)
      });
    }
  });
}

/**
 * @param {string | null} value Attribute value
 * @returns {{ action: string } | null}
 * @see https://github.com/jquery/jquery/blob/d0ce00cdfa680f1f0c38460bc51ea14079ae8b07/src/data.js#L20-L43
 */
function parseData(value) {
  if (value == null) return null;

  // JSON object format `data-track-click='{"action":"test","attributes":{}}'`
  if (value.startsWith('{')) {
    try {
      return JSON.parse(value);
    } catch {
      /* empty */
    }
  }

  // default `data-track-click="test"`
  return { action: value };
}
